module.exports = __webpack_public_path__ + "static/rockmount-e5ef783fa738382d0b7623f2d2771a49.png";